import React, { useState } from "react";
import {
  InputAdornment,
  IconButton,
  Autocomplete,
  TextField,
} from "@mui/material";
import "./CitySelect.css";
import { useSelector } from "@/hooks/redux";
import { isPartner } from "./utility";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import SearchIcon from "@mui/icons-material/Search";
import { t } from "@lingui/macro";

export default function CitySelect({
  city = "",
  setCity,
  onClick = undefined,
  small = false,
  displayEmpty = true,
  fullWidth = false,
  rounded = true,
  shadow = true,
}) {
  const [open, setOpen] = useState(false);
  const cities = useSelector((state) => state.General.cities);
  const cityElem = cities.find((x) => x.value === city) ?? null;
  const [inputValue, setInputValue] = useState("");
  const [isReadOnly, setIsReadOnly] = useState(false);

  const handleOpen = (event) => {
    event.stopPropagation();
    event.preventDefault();
    setOpen(true);
  };

  const handleClose = (event) => {
    event.stopPropagation();
    event.preventDefault();
    setOpen(false);
    setIsReadOnly(false);
  };

  return (
    <div
      className={`row city-selector ${small ? "small" : ""} ${
        fullWidth ? "mx-0 w-100" : ""
      } ${rounded ? "rounded" : ""} ${shadow ? "shadow" : ""}`}
    >
      {/* <FormControl className="ml-2 ">
          <InputLabel>Città</InputLabel> */}
      <Autocomplete
        size={small ? "small" : "medium"}
        open={open}
        onClose={handleClose}
        onOpen={handleOpen}
        sx={{
          flex: 1,
          willChange: "transform",
        }}
        autoFocus={false}
        fullWidth={fullWidth}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={t`Seleziona città`}
            variant="standard"
            InputProps={{
              ...params.InputProps,
              readOnly: isReadOnly,
              startAdornment: (
                <InputAdornment position="start">
                  <LocationOnIcon
                    className="thipi-text-color"
                    sx={{ fontSize: "1.3em" }}
                  />
                </InputAdornment>
              ),
              endAdornment: params.InputProps.endAdornment,
              disableUnderline: true, // <== added this
            }}
          />
        )}
        disableUnderline
        getOptionLabel={(option) => option.label}
        options={cities}
        value={cityElem}
        inputValue={inputValue}
        groupBy={(option) =>
          !isPartner() ? option.group ?? t`Altre` : undefined
        }
        onInputChange={(_e, value) => setInputValue(value ?? "")}
        displayEmpty={displayEmpty}
        variant="standard"
        className="ml-2"
        onChange={(_e, option) => {
          if (!option || option === city || option === "") return;
          setCity(option.value);
        }}
        classes={{
          listbox: "custom-scrollbar-noMobile",
          groupLabel: "font-weight-bold",
        }}
        MenuProps={{
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "left",
          },
          transformOrigin: {
            vertical: "top",
            horizontal: "left",
          },
          getContentAnchorEl: null,
        }}
      />
      {/* </FormControl> */}
      {onClick && (
        <div className="my-auto">
          <IconButton
            size="small"
            className="roundIcon orange ml-auto p-1"
            aria-label="search"
            onClick={city ? onClick : () => setOpen(true)}
          >
            <SearchIcon
              className="text-white"
              sx={{ fontSize: "1.2em", strokeWidth: 0.5, stroke: "currentColor" }}
            />
          </IconButton>
        </div>
      )}
    </div>
  );
}
